// Archived signature evidence and current-version acceptance are separate truths.
export function doctorBillingAgreementState(row = {}, currentVersion = "") {
  const agreementPath = String(row.billing_agreement_path || "").trim();
  const agreementSignedAt = String(row.billing_agreement_signed_at || "").trim();
  const agreementVersion = String(row.billing_agreement_version || "").trim();
  const agreementReady = Boolean(agreementPath && agreementSignedAt && Number.isFinite(Date.parse(agreementSignedAt)));
  return { agreementPath, agreementSignedAt, agreementVersion, agreementReady,
    agreementCurrent: agreementReady && agreementVersion === currentVersion };
}
